"use client";
import { useEffect, useRef, useState } from "react";
type Review = { author: string; rating: number; text: string; propertyId: string };

export function VerifiedReviews({ agencyId, title, limit = 6, propertyId = "" }: { agencyId?: string; title: string; limit?: number; propertyId?: string }) {
  const ref = useRef<HTMLElement>(null);
  const [reviews, setReviews] = useState<Review[]>([]);
  const [state, setState] = useState("loading");
  useEffect(() => {
    if (!agencyId || !ref.current) return;
    const controller = new AbortController();
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((item) => item.isIntersecting)) return;
      observer.disconnect();
      fetch(`/api/site/${encodeURIComponent(agencyId)}/reviews`, { signal: controller.signal }).then(async (response) => {
        if (!response.ok) throw new Error("Unavailable");
        return response.json();
      }).then((result) => { setReviews(Array.isArray(result.reviews) ? result.reviews : []); setState("ready"); }).catch(() => { if (!controller.signal.aborted) setState("error"); });
    }, { rootMargin: "200px" });
    observer.observe(ref.current);
    return () => { controller.abort(); observer.disconnect(); };
  }, [agencyId]);
  const visible = reviews.filter((item) => !propertyId || item.propertyId === propertyId).slice(0, Math.min(12, Math.max(1, limit)));
  return <section ref={ref} style={{ padding: "64px clamp(20px,5vw,72px)", maxWidth: 1280, margin: "auto" }}>
    <h2 style={{ color: "var(--site-ink)", fontSize: "clamp(28px,4vw,42px)", letterSpacing: "-.04em" }}>{title}</h2>
    <p style={{ color: "var(--site-muted)" }}>Reseñas de estancias reservadas y pagadas en esta web, revisadas antes de su publicación.</p>
    {!visible.length && <p role="status">{!agencyId ? "Las reseñas publicadas de tu agencia aparecerán aquí." : state === "loading" ? "Cargando opiniones…" : state === "error" ? "No se pueden cargar las opiniones en este momento." : "Todavía no hay opiniones publicadas."}</p>}
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,260px),1fr))", gap: 20 }}>{visible.map((review, index) => <article key={index} style={{ border: "1px solid #e2e8f0", borderRadius: 20, padding: 24 }}>
      <span aria-label={`${review.rating} de 5 estrellas`} style={{ color: "#926400" }}>{"★".repeat(Math.min(5, Math.max(1, review.rating)))}</span>
      <blockquote style={{ margin: "16px 0", whiteSpace: "pre-wrap", overflowWrap: "anywhere", lineHeight: 1.7 }}>{review.text}</blockquote><strong>{review.author}</strong>
    </article>)}</div>
  </section>;
}
